import React from 'react';
import { Typography, Row, Col, Statistic } from 'antd';
import {
  SwapOutlined,
  TeamOutlined,
  FlagOutlined,
  ClockCircleOutlined,
  RiseOutlined,
  MessageOutlined,
  FieldTimeOutlined,
} from '@ant-design/icons';
import { useGetAnalyticsOverviewQuery } from '../services/adminApi';

const { Title, Text } = Typography;

export default function DashboardPage() {
  const { data: stats, isLoading } = useGetAnalyticsOverviewQuery();

  const statCards = [
    { title: 'Total Deals', value: stats?.totalDeals || 0, icon: <SwapOutlined />, color: 'var(--df-primary)' },
    { title: 'Active Users', value: stats?.activeUsers || 0, icon: <TeamOutlined />, color: 'var(--df-info)' },
    { title: 'Pending Review', value: stats?.pendingReview || 0, icon: <ClockCircleOutlined />, color: 'var(--df-warning)' },
    { title: 'Open Reports', value: stats?.openReports || 0, icon: <FlagOutlined />, color: 'var(--df-error)' },
    { title: 'Total Votes', value: stats?.totalVotes || 0, icon: <RiseOutlined />, color: 'var(--df-success)' },
    { title: 'Total Comments', value: stats?.totalComments || 0, icon: <MessageOutlined />, color: 'var(--df-primary-muted)' },
    { title: 'Expired Deals', value: stats?.expiredDeals || 0, icon: <FieldTimeOutlined />, color: 'var(--df-text-secondary)' },
  ];

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 24, gap: 12, flexWrap: 'wrap' }}>
        <div>
          <Title
            level={3}
            style={{ margin: 0, color: 'var(--df-text)', fontFamily: 'var(--df-font-display)' }}
          >
            Dashboard
          </Title>
          <Text style={{ fontSize: 13, color: 'var(--df-text-secondary)' }}>
            {new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
          </Text>
        </div>
        <Text style={{ fontSize: 13, display: 'flex', alignItems: 'center', gap: 6, color: 'var(--df-text-secondary)' }}>
          <span
            style={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              background: 'var(--df-success)',
              display: 'inline-block',
            }}
            aria-hidden="true"
          />
          Live overview
        </Text>
      </div>

      <Row gutter={[16, 16]}>
        {statCards.map((card) => (
          <Col xs={24} sm={12} lg={8} xl={6} key={card.title}>
            <div
              style={{
                borderRadius: 12,
                border: '1px solid var(--df-border)',
                background: 'var(--df-surface-elevated)',
                boxShadow: 'var(--df-shadow)',
                padding: 18,
                height: '100%',
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
                <div
                  style={{
                    width: 40,
                    height: 40,
                    borderRadius: 10,
                    background: 'rgba(11, 58, 92, 0.08)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: card.color,
                    fontSize: 18,
                  }}
                >
                  {card.icon}
                </div>
                <Text style={{ fontSize: 12, fontWeight: 600, color: 'var(--df-text-secondary)' }}>
                  {card.title}
                </Text>
              </div>
              <Statistic
                value={isLoading ? '—' : card.value}
                valueStyle={{
                  fontSize: 28,
                  fontWeight: 700,
                  color: 'var(--df-text)',
                  fontFamily: 'var(--df-font-display)',
                  padding: 0,
                }}
              />
            </div>
          </Col>
        ))}
      </Row>

      <div
        style={{
          marginTop: 24,
          padding: 22,
          background: 'var(--df-surface-elevated)',
          borderRadius: 12,
          border: '1px solid var(--df-border)',
          boxShadow: 'var(--df-shadow)',
        }}
      >
        <Title
          level={5}
          style={{ margin: '0 0 8px', color: 'var(--df-text)', fontFamily: 'var(--df-font-display)' }}
        >
          Operator focus
        </Title>
        <Text style={{ color: 'var(--df-text-secondary)', fontSize: 14, display: 'block', marginBottom: 16 }}>
          Use Moderation for open reports, Deals for pending review, and Analytics for deeper trends.
        </Text>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          {[
            { label: 'Review open moderation cases', hint: 'Content → Moderation' },
            { label: 'Clear pending deal submissions', hint: 'Content → Deals' },
            { label: 'Check feature flags before launches', hint: 'Configure → Feature Flags' },
          ].map((item) => (
            <div
              key={item.label}
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 12,
                padding: '10px 0',
                borderBottom: '1px solid var(--df-border-subtle)',
              }}
            >
              <Text style={{ fontSize: 13, color: 'var(--df-text)' }}>{item.label}</Text>
              <Text style={{ fontSize: 12, color: 'var(--df-text-muted)' }}>{item.hint}</Text>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
